import { render, staticRenderFns } from "./ChangeAffiliationConfirm.vue?vue&type=template&id=dfafae06&scoped=true&"
import script from "./ChangeAffiliationConfirm.vue?vue&type=script&lang=js&"
export * from "./ChangeAffiliationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAffiliationConfirm.vue?vue&type=style&index=0&id=dfafae06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfafae06",
  null
  
)

export default component.exports